import { ReactElement } from 'react';
import { ContractorCardPropsType } from '..';

export type InfoLinkPropsType = Pick<ContractorCardPropsType, 'sendContractorCardAnalytics'> & {
  link: string;
  icon: ReactElement;
  linkType: 'phone' | 'web';
};

const InfoLink = ({ link, icon, sendContractorCardAnalytics, linkType }: InfoLinkPropsType) => {
  const isPhoneLink = linkType === 'phone';
  return (
    <>
      {link ? (
        <span
          data-testid={`about-${link}`}
          className="text-teal-darker flex items-center space-x-8 flex-row mb-8"
        >
          {icon}
          <a
            href={
              // for phone numbers, regex gets only digits and removes first character if it is a 1
              isPhoneLink
                ? `tel:+1${link.replace(/\D/g, '').replace(/^1/, '')}`
                : link.includes('http')
                ? link
                : `https://${link}`
            }
            target={isPhoneLink ? '_self' : '_blank'}
            rel="noreferrer"
            onClick={() => sendContractorCardAnalytics?.(linkType)}
          >
            {link}
          </a>
        </span>
      ) : null}
    </>
  );
};

export default InfoLink;
